// extracted by mini-css-extract-plugin
export default {"title":"SurveyDetails_title__DFJCC"};